export default{ADMIN:'admin',ASSISSTANT_SECURITY_MANAGER:'asst-sec-mngr',EMPLOYEE:'employee',SECURITY_MANAGER:'sec-mngr'};